export const AppOperator = {
  DEFAULT: 'default',
  TAURON: 'tauron',
  ENEA: 'enea',
} as const;

export type AppOperator = (typeof AppOperator)[keyof typeof AppOperator];

export const Theme = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export type Theme = (typeof Theme)[keyof typeof Theme];
